/**
 * useMarchio — il nome in cima al menu, dal parametro della struttura
 * (utils/marchio.js dice perche', la regola dell'evidenza e il ripiego).
 *
 * UNA RICHIESTA PER PAGINA. Il nome si chiede una volta, a GET
 * /api/marchio, e si tiene per la vita della pagina: il guscio (Layout)
 * si rimonta a ogni schermata, e richiederlo ogni volta farebbe una
 * lettura in piu' a ogni clic e un nome che lampeggia. Chi cambia il
 * parametro lo vede alla prossima apertura della pagina (o alla ricarica
 * automatica dopo un rilascio).
 *
 * MENTRE ARRIVA: null, e il menu tiene il posto vuoto (non il ripiego): un
 * «Gestionale» che diventa un altro nome un istante dopo sembrerebbe un
 * errore. Se la rotta non risponde: il ripiego, e quel fallimento NON si
 * tiene - la schermata dopo riprova, invece di restare sul ripiego fino
 * alla prossima ricarica per un intoppo di rete.
 */
import { useEffect, useState } from 'react';
import api from '../services/api';
import { partiDelMarchio } from '../utils/marchio';

let tenuto = null;      // le parti del nome, quando la rotta ha risposto
let inCorso = null;     // la richiesta partita, condivisa da chi la aspetta

function chiedi() {
    if (!inCorso) {
        inCorso = api.get('/marchio')
            .then((r) => {
                const valore = r?.data?.data?.marchio;
                tenuto = partiDelMarchio(typeof valore === 'string' ? valore : '');
                return tenuto;
            })
            .catch(() => partiDelMarchio(''))
            .finally(() => { inCorso = null; });
    }
    return inCorso;
}

export default function useMarchio() {
    const [parti, setParti] = useState(tenuto);
    useEffect(() => {
        if (tenuto) return undefined;
        let vivo = true;
        chiedi().then((p) => { if (vivo) setParti(p); });
        return () => { vivo = false; };
    }, []);
    return parti;
}
